function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.375 19.3838C17.1364 19.3838 19.375 17.1452 19.375 14.3838C19.375 11.6224 17.1364 9.38379 14.375 9.38379C11.6136 9.38379 9.375 11.6224 9.375 14.3838C9.375 17.1452 11.6136 19.3838 14.375 19.3838Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.585 14.3838H14.375V12.1738",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.375 8.75879H8.75",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.375 11.8838H6.875",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.375 15.0088H6.875",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.125 19.3838H1.875C1.18464 19.3838 0.625 18.8241 0.625 18.1338V5.00879C0.625 4.31843 1.18464 3.75879 1.875 3.75879H5C5 2.0329 6.39911 0.633789 8.125 0.633789C9.85089 0.633789 11.25 2.0329 11.25 3.75879H14.375C15.0654 3.75879 15.625 4.31843 15.625 5.00879V6.88379",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.125 3.13379C8.29759 3.13379 8.4375 3.2737 8.4375 3.44629C8.4375 3.61888 8.29759 3.75879 8.125 3.75879C7.95241 3.75879 7.8125 3.61888 7.8125 3.44629C7.8125 3.2737 7.95241 3.13379 8.125 3.13379",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgApprovationIconWhite = function SvgApprovationIconWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApprovationIconWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/approvation-icon-white.7e5a1f0d.svg";
export { ForwardRef as ReactComponent };